import React from "react";

const RenderIcon = React.memo(({ device, animate, heading }) => {
  const iconStyle = {
    color: device.color || "#000",
    animation: animate ? "pulse-device 1.5s ease infinite" : "none",
  };
  if (device?.ignore_heading || !animate) {
    return (
      <div className="icon-wrapper" style={iconStyle} title={device.title ?? ""}>
        <h6
          style={{
            position: "absolute",
            top: "-17px",
            color: "#000",
            whiteSpace: "nowrap",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {device.text || ""}
        </h6>
        <i className={device.iconClassName || "fas fa-map-pin"} style={{ fontSize: "24px" }}></i>
      </div>
    );
  }

  if (heading < 45 || heading > 315) {
    return (
      <div className="icon-wrapper" style={iconStyle} title={device.title ?? ""}>
        <div style={{ fontSize: "24px", position: "absolute", right: "9px", top: "-27px" }}>
          <i className="fas fa-arrow-up"></i>
        </div>
        <i className={device.iconClassName || "fas fa-map-pin"} style={{ fontSize: "24px" }}></i>
        <h6
          style={{
            position: "absolute",
            top: "40px",
            color: "#000",
            whiteSpace: "nowrap",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {device.text || ""}
        </h6>
      </div>
    );
  }

  if (heading > 135 && heading < 225) {
    return (
      <div className="icon-wrapper" style={iconStyle} title={device.title ?? ""}>
        <h6
          style={{
            position: "absolute",
            top: "-17px",
            color: "#000",
            whiteSpace: "nowrap",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {device.text || ""}
        </h6>
        <div style={{ fontSize: "24px", position: "absolute", right: "9px", top: "39px" }}>
          <i className="fas fa-arrow-down"></i>
        </div>
        <i className={device.iconClassName || "fas fa-map-pin"} style={{ fontSize: "24px" }}></i>
      </div>
    );
  }

  const flip = heading >= 225 && heading <= 315 ? "scaleX(-1)" : "scaleX(1)";
  return (
    <div className="icon-wrapper" style={iconStyle} title={device.title ?? ""}>
      <h6
        style={{
          position: "absolute",
          top: "-17px",
          color: "#000",
          whiteSpace: "nowrap",
          fontSize: "12px",
          fontWeight: "bold",
        }}
      >
        {device.text || ""}
      </h6>
      <i
        className={device.iconClassName || "fas fa-map-pin"}
        style={{ fontSize: "24px", transform: flip }}
      ></i>
    </div>
  );
});

export default RenderIcon;